import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "127.257",
  height: "148.265"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#1a1818",
      d: "M68.88 42.621h.408v51.1H33.127ZM68.88 0 0 98.373v19.189h69.288v30.7h33.935v-30.7h24.038V93.726h-24.042V-.004Z",
      "data-name": "Path 1812",
      opacity: ".02"
    }, null, -1)
  ])))
}
export default { render: render }